// Libraries
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SelectContainer = styled.div`
    border-radius: 3px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 100%;

    &:after {
        border: solid #d8d8d8;
        border-width: 0 2px 2px 0;
        content: '';
        display: inline-block;
        padding: 4px;
        pointer-events: none;
        position: absolute;
        right: 15px;
        top: 17px;
        transform: translateY(-50%) rotate(45deg);
    }
`;


const SelectElement = styled.select`
    appearance: none;
    background-color: white;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
    color: #000;
    cursor: pointer;
    display: inline-block;
    font-family: 'lato-regular';
    font-size: 13px;
    height: 36px;
    outline: 0;
    padding: 0 13px;
    vertical-align: middle;
    width: 100%;
    z-index: 1;
`;

const StyledErrorWrapper = styled.span`
    color: #f00;
    display: inline-block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const Spinner = styled.div`
    display: inline-block;
`;

const InfoElementWrapper = styled.span`
    display: block;
    font-size: 12px;
    margin: 4px 0 0;
    color: #919090;
`;

const Select = props => {
    const {
        id,
        input,
        wrapperClass,
        className,
        data,
        label,
        valueField,
        labelField,
        handleChange,
        resetSelect,
        defaultSelected,
        hideErrors,
        meta,
        disabled = false,
        loader,
        infoElement
    } = props;

    const [selectValue, setSelectValue] = useState(defaultSelected || '');

    function handleSelectChange(event) {
        const originalData = data.find(
            item => item[valueField] === event.target.value
        );
        if (input) {
            input.onChange(event.target.value, originalData);
        } else {
            handleChange && handleChange(event.target.value, originalData);
            setSelectValue(event.target.value);
        }
    }

    useEffect(() => {
        setSelectValue(defaultSelected || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultSelected]);

    useEffect(() => {
        if (resetSelect) {
            setSelectValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetSelect]);

    return (
        <SelectContainer className={wrapperClass || ''}>
            <SelectElement
                id={id}
                data-testid={id}
                data
                className={className || disabled ? 'disabled' : ''}
                onChange={event => handleSelectChange(event)}
                value={input ? input.value : selectValue}
                data-value={input ? input.value : selectValue}
                disabled={disabled}
            >
                {label && <option value="">{label}</option>}
                {data.map((item, index) => (
                    <option value={item[valueField]} key={index}>
                        {item[labelField]}
                    </option>
                ))}
            </SelectElement>
            {!hideErrors && meta && meta.touched && meta.error && (
                <StyledErrorWrapper className="error-message">
                    {meta.error}
                </StyledErrorWrapper>
            )}
            {loader ? (
                <Spinner className="spinner-wrap">
                    <div className="spinner" />
                </Spinner>
            ) : null}
            {infoElement && (
                <InfoElementWrapper>{infoElement}</InfoElementWrapper>
            )}
        </SelectContainer>
    );
};

Select.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    defaultSelected: PropTypes.string,
    handleChange: PropTypes.func,
    hideErrors: PropTypes.bool,
    input: PropTypes.node,
    label: PropTypes.string,
    labelField: PropTypes.string,
    meta: PropTypes.object,
    showPlaceholder: PropTypes.bool,
    valueField: PropTypes.string,
    wrapperClass: PropTypes.string,
    resetSelect: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    loader: PropTypes.bool,
};

export default Select;


